import { ListSubheader, MenuItem } from '@material-ui/core';
import React from 'react';

import { ISingleSelectOption } from '~/src/dash/views/singleselect-view';

interface IMenuItemsList {
  subheader: string;
  selectOption: ISingleSelectOption[];
}

const createMenuItemWithSubheader = (menuItems: ISingleSelectOption[]) => {
  const menuItemsLists = [] as IMenuItemsList[];

  menuItems.forEach((menuItem) => {
    if (menuItem.subheader !== undefined) {
      const menuItemIndex = menuItemsLists.findIndex(
        (item) => item.subheader === menuItem.subheader,
      );
      if (menuItemIndex !== -1) {
        menuItemsLists[menuItemIndex].selectOption.push(menuItem);
      } else {
        const newMenuItems = {
          subheader: menuItem.subheader,
          selectOption: [menuItem],
        } as IMenuItemsList;
        menuItemsLists.push(newMenuItems);
      }
    }
  });
  return menuItemsLists;
};

export function SelectDropdownWithSubheaderView(menuItems: ISingleSelectOption[]) {
  const menuItemsLists = createMenuItemWithSubheader(menuItems);
  const options = [] as any[];
  menuItemsLists.forEach((element: IMenuItemsList) => {
    options.push(
      <ListSubheader
        style={{ backgroundColor: '#fafafa', color: '#000000', pointerEvents: 'none' }}
      >
        {element.subheader}
      </ListSubheader>,
    );
    element.selectOption.forEach((item: ISingleSelectOption) => {
      options.push(<MenuItem value={item.value}>{item.label}</MenuItem>);
    });
  });
  return options;
}
